import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Button from '../Button';

const CancelButton = ({ children = undefined, ...rest }) => {
  const intl = useIntl();

  return (
    <Button variant="secondary" { ...rest }>
      { children || intl.formatMessage({ id: 'cancel' }) }
    </Button>
  );
};

CancelButton.propTypes = {
  children: PropTypes.node
};

export default CancelButton;
